export default function SkipLink() {
  return (
    <a href="#main-content" className="skip-link">
      Pular para o conteúdo principal
    </a>
  )
}
